<template>
  <div :style="{'min-height': clientHeight + 'px','background-color':'#F7F7F7'}" id="outermost">

    <van-nav-bar
      title="一企一档"
      left-text="返回"
      :right-text="showBackTier ? '上一层' : ''"
      left-arrow
      @click-left="$router.back()"
      @click-right="backTier"
      id="topbar"/>

    <div style="padding-top: 10px;">

      <van-search v-model="folderName" placeholder="搜索" shape="round" background="#F7F7F7" style="margin-bottom: 10px;"/>
      <van-empty class="custom-empty" v-if="filteredFolderList.length===0" description="暂无文件" />
      <van-radio-group :value="catalogueId" v-else>
        <van-cell-group>
          <van-cell v-for="(item, index) in filteredFolderList"
                    :key="index" clickable @click="handleCatalogue(item)">

            <template #title>
              <div class="cell-title-ellipsis">{{ item.name || '' }}</div>
            </template>
            <template #label>
              <div class="cell-label-ellipsis">{{ item.createTime || '' }}</div>
            </template>

            <template #icon>
              <img v-if="item.code === 'file' && getNameSuffix(item.name) === 'image'" src="../../assets/project/image.png"  style="width: 30px; height: 36px;margin-right: 10px" alt="">
              <img v-if="item.code === 'file' && getNameSuffix(item.name) === 'zip'" src="../../assets/project/zip.png"  style="width: 30px; height: 36px;margin-right: 10px" alt="">
              <img v-if="item.code === 'file' && getNameSuffix(item.name) === 'excel'" src="../../assets/project/excel.png"  style="width: 30px; height: 36px;margin-right: 10px" alt="">
              <img v-if="item.code === 'file' && getNameSuffix(item.name) === 'ppt'" src="../../assets/project/ppt.png"  style="width: 30px; height: 36px;margin-right: 10px" alt="">
              <img v-if="item.code === 'file' && getNameSuffix(item.name) === 'pdf'" src="../../assets/project/pdf.png"  style="width: 30px; height: 36px;margin-right: 10px" alt="">
              <img v-if="item.code === 'file' && getNameSuffix(item.name) === 'txt'" src="../../assets/project/txt.png"  style="width: 30px; height: 36px;margin-right: 10px" alt="">
              <img v-if="item.code === 'file' && getNameSuffix(item.name) === 'world'" src="../../assets/project/world.png"  style="width: 30px; height: 36px;margin-right: 10px" alt="">
              <img v-if="item.code !== 'file'" src="../../assets/project/folder.png"  style="width: 45px; height: 36px;margin-right: 10px" alt="">
            </template>

            <template #right-icon>
              <van-radio :name="item.id" @click.stop="handleRadio(item.id)"/>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>

    <div style="position: fixed; bottom: 0; width: 100%; padding: 10px; background: #fff;">
      <van-button type="primary" block @click="handleDownload" :disabled="!catalogueId">下载</van-button>
    </div>
  </div>
</template>

<script>
import $ from '@/fly'
import Setting from '@/setting';
import {NavBar, Search, Cell, CellGroup, Radio, Button, Icon, Toast} from 'vant';
import _ from "lodash";
import {createPreView} from "@/utils/PreView";

export default {
  name: 'project-companyArchives',
  components: {
    VanNavBar: NavBar,
    VanSearch: Search,
    VanCell: Cell,
    VanCellGroup: CellGroup,
    VanRadio: Radio,
    VanButton: Button,
    VanIcon: Icon
  },
  data() {
    return {
      folderName: '',
      clientHeight: window.screen.height,
      companyId:'',
      folderList: [],
      catalogueId: '',
      catalogueList:[],
      showBackTier: ''
    };
  },
  computed: {
    filteredFolderList() {
      if (!this.folderName) return this.folderList;
      return this.folderList.filter(item =>
        item.name.includes(this.folderName)
      );
    }
  },
  async created() {
    this.initBaseData();
    await this.loadInfo();
  },
  methods: {
    // 取消单选
    handleRadio(catalogueId) {
      this.catalogueId = this.catalogueId === catalogueId ? '' : catalogueId;
    },
    // 获取后缀
    getNameSuffix(name) {
      const lastDot = name.lastIndexOf('.');
      const suffix = lastDot <= 0 ? '' : name.slice(lastDot + 1).toLowerCase();
      if (suffix === 'zip') return 'zip';
      if (suffix === 'pdf') return 'pdf';
      if (suffix === 'txt' ) return 'txt';
      if (suffix === 'ppt' || suffix === 'pptx') return 'ppt';
      if (suffix === 'jpg' || suffix === 'png' || suffix === 'gif' ) return 'image';
      if (suffix === 'doc' || suffix === 'docx') return 'world';
      if (suffix === 'xls' || suffix === 'xlsx' ) return 'excel';
    },
    // 初始化基础数据
    initBaseData() {
      this.companyId = localStorage.getItem('companyId');
    },
    // 加载企业目录信息
    async loadInfo() {
      try {
        const res = await $.get('archivesCatalogue/getFirstLevelCatalogue/' + this.companyId);
        this.catalogueList = res || [];
        this.folderList = res || [];
      } catch (error) {
        Toast.fail('加载失败');
      }
    },
    //返回上一层
    backTier() {
      if (this.showBackTier && this.showBackTier === '0') {
        this.folderList = _.cloneDeep(this.catalogueList);
        this.showBackTier = ''
      } else {
        this.catalogueList.forEach(item => {
          if (item.id === this.showBackTier) {
            this.folderList = item.children
            this.showBackTier = item.parentId
          } else {
            if (item.children && item.children.length > 0) {
              item.children.forEach(childrenCatalogue => {
                if (childrenCatalogue.id === this.showBackTier) {
                  this.folderList = item.children
                  this.showBackTier = item.parentId
                }
              })
            }
          }
        })
      }
    },
    //构建目录
    handleCatalogue(item) {
      if (item.code === 'file') {
        window.open(createPreView(Setting.apiBaseURL + 'download/' + item.id,item.name));
      } else {
        this.showBackTier = item.parentId
        this.catalogueId = '';
        this.folderList = item.children || []
      }
    },
    // 目录文件下载
    async handleDownload() {
      if (!this.catalogueId) return;
      const targetItem = this.folderList.find(item => item.id === this.catalogueId);
      //
      if (targetItem && targetItem.code === 'file') {
        await this.downloadFile(targetItem.id)
      } else {
        try {
          const res = await $.get('archivesFile/getList', {
            companyId: this.companyId,
            catalogueId: this.catalogueId,
          });

          if (res && res.length > 0) {
            const fileItems = res.filter(item => item.attachmentId && item.attachmentId.trim());

            if (fileItems.length === 0) {
              Toast('该目录下没有可下载的文件');
              return;
            }

            await this.downloadWithDelayQueue(fileItems);
          } else {
            Toast('该目录下没有文件');
          }
        } catch (error) {
          Toast.fail('获取文件列表失败');
        }
      }
    },
    // 延迟队列下载
    async downloadWithDelayQueue(fileItems) {
      Toast.loading({
        message: '开始批量下载...',
        duration: 0,
        forbidClick: true
      });

      const downloadQueue = [];

      for (let i = 0; i < fileItems.length; i++) {
        const item = fileItems[i];
        const attId = item.attachmentId.trim();

        // 为每个下载创建一个 Promise
        downloadQueue.push(
          new Promise(async (resolve) => {
            try {
              const delay = i === 0 ? 0 : 1000;
              await new Promise(resolveDelay => setTimeout(resolveDelay, delay));
              await this.downloadFile(attId);
              resolve({ success: true, index: i });
            } catch (error) {
              console.error(`文件 ${i + 1} 下载失败:`, error);
              resolve({ success: false, index: i, error: error.message });
            }
          })
        );
      }
      // 等待所有下载完成
      const results = await Promise.all(downloadQueue);
      Toast.clear();
      const successCount = results.filter(r => r.success).length;
      const failCount = results.filter(r => !r.success).length;

      if (failCount === 0) {
        Toast.success(`下载完成，共 ${successCount} 个文件`);
      } else {
        Toast(`下载完成，成功 ${successCount} 个，失败 ${failCount} 个`);
      }
    },
    // 下载单个文件的方法
    downloadFile(attId) {
      return new Promise((resolve, reject) => {
        try {
          const iframe = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.src = `${Setting.apiBaseURL}download/${attId}`;
          document.body.appendChild(iframe);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>

.van-search__content {
  border: 1px solid #8da0eb;
}
.van-cell {
  align-items: center;
  .van-cell__title {
    font-size: 16px;
  }
  .van-cell__label {
    font-size: 12px;
    color: #999;
  }
}
.van-button--primary {
  background-color: #1989fa;
  border-radius: 8px;
}

.cell-title-ellipsis {
  max-width: 68vw; /* 可根据需求调整宽度 */
  white-space: nowrap; /* 强制单行显示 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 显示省略号 */
}

/* 标签（时间）省略号样式（可选） */
.cell-label-ellipsis {
  max-width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/deep/.custom-empty {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .van-empty__description {
    font-size: 16px !important;
    color: #666 !important;
    margin-top: 30px !important;
  }
}
</style>
